import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 4h10v15H7zM3 6h2v11H3zM19 6h2v11h-2z"
}), 'AmpStories');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AmpStories.js
// module id = 2037
// module chunks = 2